<template>
    <el-dialog  title="新增报警类型" :visible.sync="showBlock" :close-on-click-modal="false"  :destroy-on-close="true" width='400px' :before-close="closedBtn">
            <el-form :model="formDate"  status-icon  ref="formDate" label-width="80px" class="demo-ruleForm">
                <el-form-item  label="类型名称" prop="name" :rules="[{required:true,message:'类型名称不可为空'}]">
                    <el-input v-model="formDate.name" maxlength="100"  :size="this.$store.state.popSize" style="width:100%"    placeholder="请输入模版名称" autocomplete="off"></el-input>
                </el-form-item>
                <div class="warp-btn">
                    <el-form-item>
                        <div  class="dialog-footer">
                            <el-button @click="closedBtn">取消</el-button>
                            <el-button type="primary"  v-if="showBtn">
                              <i class="el-icon-loading"></i>提交
                            </el-button>
                            <el-button type="primary" v-else @click="submitForm('formDate')">提交</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
    </el-dialog>
</template>
<script>
  import {postFun,putFun} from '@/utils/httpFun'
  import {operate} from '@/utils/config'
  import TReeBlock from '@/components/component-block/block-newTree.vue'
  export default {
    components:{
        TReeBlock
    },
    data:()=>({
        showBlock:false,
        showBtn:false,
        mark:null,
        value:"",
       
        formDate:{
           dtId:"",         //设备类型ID
           name:""//报警类型名称   
        }
    }),
    props:{
        
    },
    mounted(){
        
    },
    methods:{
        closedBtn(){
           this.showBlock = false
           this.formDate.name = ""
        },
        openBtn(ev){
            
           this.showBlock = true 
           this.$nextTick(res=>{
              this.mark = ev.mark
              this.formDate.dtId = ev.dtId
              if(ev.mark=="eidt"){
                 this.formDate.id = ev.id
                 this.formDate.name = ev.policeTypeName
              }
           }) 
        },

        //提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitBtn()
                }else{
                    return false;
                }
            });
        },

        //提交
        submitBtn(){
            let parms = {
                policeTypeName:this.formDate.name,        
                dtId:this.formDate.dtId,         
            }
            parms.operator = this.$store.state.operator
            if(this.mark=="add"){
                postFun(operate.BAOJINGTYPEADD,parms,res=>{
                    if(res.data){
                    this.closedBtn()
                    this.$parent.resetBtn()
                    }
                })
            }else{
                parms.id = this.formDate.id
                putFun(operate.BAOJINGTYPEEIDT,parms,res=>{
                    if(res.data){
                    this.closedBtn()
                    this.$parent.resetBtn()
                    }
                })
            }
           
        }
    }
 }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   ::v-deep .el-input-number .el-input__inner{
        text-align: left!important;
    } 
    
   .warp-btn{
    margin-top: 20px;
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
</style>